import { Progress, Spinner } from '@agro-club/agroclub-shared'
import { FC, useEffect } from 'react'
import { useDealContext } from '../DealContext'
import { SampleRequestBlock } from '../../../../components/Sample/SampleRequest/SampleRequestBlock'

export const DealSamples: FC<{ setSummary: (value: boolean) => void }> = ({ setSummary }) => {
  const { deal, samplesInfo, dealRefetch } = useDealContext()

  useEffect(() => {
    if (samplesInfo.progress === Progress.SUCCESS) {
      setSummary(!!samplesInfo.data?.length)
    }
  }, [samplesInfo.data, samplesInfo.progress, setSummary])

  if (!samplesInfo.data) {
    return <Spinner />
  }

  return (
    <SampleRequestBlock
      deal={deal}
      dealRefetch={dealRefetch}
      bid={deal.sale_bid}
      data={samplesInfo.data}
      refetch={samplesInfo.refetch}
      bidId={deal.sale_bid.id as any} // todo number
    />
  )
}
